/**** KMS forms token ****/
function add_csrf_to_form(form, csrf_token) {
    if (!form.querySelector("input[name='_csrf_token']")) {
        form.insertAdjacentHTML('afterbegin','<input type="hidden" name="_csrf_token" value="' + csrf_token + '">');
        }
}
function add_csrf_to_forms(csrf_token) {
    const post_forms = document.querySelectorAll("form[method='POST']");
    for (var i =0; i < post_forms.length; i++) {
        var form = post_forms[i];
        add_csrf_to_form(form, csrf_token)
    }
}
function check_form_csrf() {
    // Check if any forms are missing csrf_token
    const post_forms = document.querySelectorAll("form[method='POST']");
    for (var i =0; i < post_forms.length; i++) {
        var form = post_forms[i];
        if (!form.querySelector("input[name='_csrf_token']")) {
            // If we have any forms without a CSRF token, get a token and populate all forms
            get_csrf().then(
                (csrf_token) => add_csrf_to_forms(csrf_token)
            )
            break;
        }
    }
}
async function get_csrf_async() {
    if (window.kms && window.kms.csrf_token) {
        return window.kms.csrf_token;
    }
    window.kms = window.kms || {};
    // console.log("fetching csrf token");
    window.kms.csrf_token = await fetch('/kms/csrf_token').then((response) => {
        if (response.ok) {
            return response.json();
          } else {
            throw new Error('Something went wrong');
          }
    }).then((responseJson) => {
        return responseJson.csrf_token;
    })
    .catch(function(err) {
        console.log('Error retrieving form token', err);
    });
    return window.kms.csrf_token;
        
}
// Prevent multiple retrievals of the CSRF token which could all create different tokens.
function get_csrf_cached(){
    let cache = null;
    return async function(){
        cache = cache || get_csrf_async.apply(this)
        return cache
    }
}
export const get_csrf = get_csrf_cached();
document.addEventListener("DOMContentLoaded", check_form_csrf);
